// Contexts
import { fetchFeatureFlagsInformationService } from 'providers/feature-flags/services/feature-flags.service';
// Types
import { FeatureFlagType } from 'types/feature-flag.type';
// Utilities
import { isFeatureFlagsLegitApiResponse } from './utils/feature-flags.resolver.utils';

const fetchFeatureFlagsInformationResolver = async (): Promise<
  [FeatureFlagType[]] | [null, true]
> => {
  const [response] = await fetchFeatureFlagsInformationService();

  return isFeatureFlagsLegitApiResponse(response) ? [response as FeatureFlagType[]] : [null, true];
};

export { fetchFeatureFlagsInformationResolver };
